import React, { useState, useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import 'intersection-observer'
import styled from 'styled-components'
import { Section } from './Section'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import horizontalLogo from '../assets/midway-driving-school-logo-horizontal.png'
import Hamburger from './Hamburger'
import BackgroundImage from 'gatsby-background-image'

const Container = styled(Section)`
  height: 150px;
`
const MobileContainer = styled.div`
  border-bottom: 1px solid #ccc;
  height: 60px;
  position: sticky;
  z-index: 1000;
  top: 0px;
  background-color: #fff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  div ul li {
    margin: 0px;
    padding: 0px;
  }
  ul li a.phone {
    display: inline-block;
  }
`
const LogoContainer = styled.div`
  font-size: 0;
  line-height: 0;
  left: 0;
  width: 104px;
  height: 69px;
  @media only screen and (max-width: 980px) {
    width: 45px;
    height: 30px;
  }
`

const Nav = styled.nav`
  margin: auto 0 auto auto;
  font-size: 1.125rem;
  font-weight: 700;
  right: 0;
  ul li {
    float: left;
    margin-right: 5px;
    padding: 0px 7px;
    transition: 0.17s;
  }
  ul li:last-of-type {
    margin-right: 0;
    padding-right: 0;
  }
  li a {
    padding: 9px 5px;
    cursor: pointer;
    position: relative;
    color: ${(props) => props.theme.linkAlt};
    :after {
      content: '';
      transition: 0.15s;
      height: 4px;
      width: 0;
      background-color: ${(props) => props.theme.accent};
      left: 50%;
      bottom: -3px;
      transform: translateX(-50%);
      position: absolute;
    }
    :hover:after {
      width: 100%;
    }
  }
  .phone-icon {
    @media only screen and (max-width: 400px) {
      display: none !important;
    }
  }
  .call {
    @media only screen and (max-width: 350px) {
      display: none !important;
    }
  }
  li a.phone {
    white-space: no-wrap;
    flex-wrap: nowrap;
    color: #fff;
    transition: 0.2s;
    border-radius: 100px;
    padding: 7px 5px;

    background-color: ${(props) => props.theme.accentDark};
    padding-left: 20px;
    padding-right: 20px;
    :hover {
      color: #fff;
      background-color: ${(props) => props.theme.accentDarker};
    }
    :hover:after {
      display: none;
    }
    @media only screen and (max-width: 300px) {
      display: none !important;
    }
  }
`
const StickyHeader = styled.div`
  width: 100%;
  height: 57px;
  background-color: #fff;
  position: sticky;
  z-index: 1000;
  top: 0px;
  line-height: 0px;
  margin-top: -60px;
  border-bottom: 1px solid #ccc;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  transition: 0.15s;
  > div {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    @media only screen and (max-width: 900px) {
      padding: 0 10px;
    }
  }
  li {
    margin-bottom: 0px;
  }
`
const MobileDrawer = styled.div`
  position: absolute;
  text-align: center;
  background: #efefef;
  transition: transform 0.2s;
  z-index: -1;

  ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  li {
    display: block;
  }
  li a {
    padding: 14px 0px;
    width: 100%;
    display: flex !important;
    gap: 5px;
    font-size: 1.1rem;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    font-weight: bold;
    color: #006bb7;
    background: #fff;
    border-radius: 100px;
    letter-spacing: 0.02em;
  }

  a.phone {
    color: #fff;
    background-color: ${(props) => props.theme.accentDark};
  }
`

const PhoneIcon = ({ style = {}, className }) => {
  return (
    <svg viewBox="0 0 333 416.25" style={style} className={className}>
      <path
        style={{ fill: 'currentColor' }}
        d="M32 60c30,-46 54,-66 81,-5 19,43 16,43 -13,70 -20,19 8,49 32,75 24,25 52,56 73,37 29,-27 29,-30 70,-8 60,32 37,53 -10,80 -95,50 -289,-158 -233,-249zm220 109c-4,15 -27,9 -23,-6 9,-30 -23,-64 -53,-58 -15,4 -20,-20 -5,-23 48,-10 95,40 81,87zm53 17c-2,15 -26,13 -24,-3 8,-70 -52,-133 -122,-131 -16,1 -17,-23 -1,-24 84,-3 156,74 147,158z"
      />
    </svg>
  )
}
const PhoneNumber = () => {
  return (
    <a
      className="phone"
      href={'tel:612-623-4142'}
      style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      <PhoneIcon
        className="phone-icon"
        style={{
          position: 'relative',
          marginLeft: -5,
          marginTop: 3,
          width: 25,
          height: 25
        }}
      />
      <span>
        <span className="call">Call </span>
        (612) 623-4142
      </span>
    </a>
  )
}

const WebNav = () => {
  return (
    <ul style={{ display: 'flex', alignItems: 'center' }}>
      <li>
        <Link to="/#services">Services</Link>
      </li>
      <li>
        <Link to="/#locations">Locations, Rates, and Hours</Link>
      </li>
      <li>
        <Link to="/#faq">FAQ</Link>
      </li>
      <li>
        <Link to="/contact">Contact</Link>
      </li>
      <li>
        <PhoneNumber />
      </li>
    </ul>
  )
}

const MobileNav = ({ data }) => {
  const [openMenu, setOpenMenu] = useState(false)
  return (
    <MobileContainer as={'header'} className={'mobile'}>
      <div style={{ padding: '0px 20px', height: '100%', background: '#fff' }}>
        <div style={{ height: '100%', width: '100%', position: 'relative' }}>
          <MainLogo data={data} />
          <Nav className={'mobile pos-center-vert'}>
            <ul style={{ display: 'flex', alignItems: 'center' }}>
              <li style={{ marginRight: '13px' }}>
                <PhoneNumber />
              </li>
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <Hamburger
                  showClose={openMenu}
                  onClick={() => {
                    setOpenMenu(!openMenu)
                  }}
                />
              </li>
            </ul>
          </Nav>
        </div>
      </div>
      <MobileDrawer
        style={{
          position: 'absolute',
          left: 0,
          top: '100%',
          width: '100%',
          boxShadow: openMenu ? '0px 2px 2px rgba(0, 0, 0, 0.3)' : '',
          pointerEvents: openMenu ? '' : 'none',
          transform: openMenu ? 'translateY(0)' : 'translateY(-100%)'
        }}>
        <Section>
          <ul>
            <li>
              <Link to="/#services" onClick={() => setOpenMenu(false)}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/#locations" onClick={() => setOpenMenu(false)}>
                Locations, Rates, and Hours
              </Link>
            </li>
            <li>
              <Link to="/#faq" onClick={() => setOpenMenu(false)}>
                Frequently Asked Questions (FAQ)
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={() => setOpenMenu(false)}>
                Contact
              </Link>
            </li>
            <li>
              <a className="phone" href={'tel:612-623-4142'}>
                <PhoneIcon
                  className="phone-icon"
                  style={{
                    width: 25,
                    height: 25
                  }}
                />
                <span>
                  <span className="call">Call </span>
                  (612) 623-4142
                </span>
              </a>
            </li>
          </ul>
        </Section>
      </MobileDrawer>
    </MobileContainer>
  )
}

const MainLogo = ({ data }) => {
  return (
    <LogoContainer className={'pos-center-vert'}>
      <Link
        className={'pos-full'}
        to={'/'}
        title={'Midway Driving School Homepage'}>
        <Img
          className={'pos-full'}
          fluid={data.logo.childImageSharp.fluid}
          alt={'Midway Driving School'}
        />
      </Link>
    </LogoContainer>
  )
}

const Banner = styled(BackgroundImage)`
  display: flex;
  min-height: 60px;
  padding: 10px;
  line-height: 1.15;
  color: #fff;
  font-size: 17px;
  position: relative;
  z-index: 10000;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: 0 0;
  > div {
    display: flex;
    align-items: center;
    padding-left: ${(props) =>
      props.anchor
        ? `calc(${props.theme.pad} * 6) ${props.theme.pad}`
        : `calc(${props.theme.pad} * 4) ${props.theme.pad}`};
    padding-right: ${(props) =>
      props.anchor
        ? `calc(${props.theme.pad} * 6) ${props.theme.pad}`
        : `calc(${props.theme.pad} * 4) ${props.theme.pad}`};
  }
  span {
    font-size: 18px;
    @media (max-width: 768px) {
      font-size: 15px;
    }
  }
`

export default ({}) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "midway-driving-school-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 104) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      bg: file(relativePath: { eq: "holiday-bg-6.png" }) {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const navId = 'web-nav'

  const [isSticky, setIsSticky] = useState(false) // actually get the position FIRST!
  useEffect(() => {
    let elem = document.getElementById(navId)
    let observer
    let callback = (entries) => {
      const [{ isIntersecting }] = entries
      const currIsSticky = !isIntersecting
      if (currIsSticky !== isSticky) setIsSticky(currIsSticky)
    }
    if (elem) {
      observer = new IntersectionObserver(callback, {
        rootMargin: '0px',
        threshold: [0, 1]
      })
      observer.observe(elem)
    }
    return () => {
      if (elem) {
        elem = null
        // No need to remove observer since we always need it?
      }
    }
  }, [isSticky, setIsSticky])
  return (
    <>
      {/* <Banner fluid={data.bg.childImageSharp.fluid}>
        <div
          style={{
            width: 'min(1200px, 100%)',
            margin: '0 auto'
          }}>
          <span
            style={{
              textAlign: 'center',
              padding: '8px 10px',
              background: '#fff',
              color: '#000',
              marginRight: '4px',
              borderRadius: '5px',
              fontWeight: 'bold',
              whiteSpace: 'nowrap'
            }}>
            Holiday Hours
          </span>
          <span
            style={{
              lineHeight: '1.4',
              textAlign: 'left',
              padding: '5px 10px',
              borderRadius: '4px'
            }}>
            <span style={{ whiteSpace: 'nowrap', marginRight: 5 }}>
              <u style={{ textUnderlineOffset: '.3em' }}>
                <strong>Office Closed Dec 24-28th</strong>
              </u>
            </span>{' '}
            <span style={{ whiteSpace: 'nowrap' }}>
              Lessons available Dec 26-28th.
            </span>
          </span>
        </div>
      </Banner> */}
      {/* Mobile */}
      <MobileNav data={data} />
      {/* Web */}
      <Container as={'header'} className={'mobile-none'} id={navId}>
        <div className={'pos-full'} style={{ position: 'relative' }}>
          <MainLogo data={data} />
          <MobileNav data={data} />
          <Nav className={'mobile-none pos-center-vert'}>
            <WebNav />
          </Nav>
        </div>
      </Container>
      <StickyHeader
        className={'mobile-none'}
        style={{
          opacity: isSticky ? 1 : 0,
          transform: isSticky ? 'translateY(0%)' : 'translateY(-20%)'
        }}>
        <div>
          <Link to={'/'} title={'Midway Driving School Homepage'}>
            <img
              src={horizontalLogo}
              alt={'Midway Driving School'}
              style={{ height: 21 }}
            />
          </Link>
          <Nav>
            <WebNav />
          </Nav>
        </div>
      </StickyHeader>
    </>
  )
}
